<div class="mt-3" id="box-template">
    <hot-table *ngIf="show" hotId="template" [settings]="modifiedTableSettings"></hot-table>
</div>